import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useState } from 'react'

function ConfirmModal({ modalTitle, modalBody, closeConfirmModalHandler, confirmHandler, showConfirmModal }) {
    const [btnClicked, setBtnClicked] = useState(false)

    const confirmBtnHandler = async () => {
        if (btnClicked)
            return
        setBtnClicked(true)
        await confirmHandler()
        closeConfirmModalHandler()
        setBtnClicked(false)
    }

    return (
        <Modal show={showConfirmModal} onHide={closeConfirmModalHandler} backdrop='static'
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{modalBody}</Modal.Body>
            <Modal.Footer>
                <Button key='Close' variant='secondary' onClick={closeConfirmModalHandler}>
                    Close
                </Button>
                <Button disabled={btnClicked} key='Add Child' variant='danger' onClick={confirmBtnHandler}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ConfirmModal